import {
  RumEvent,
  RumEventDomainContext,
  RumFetchResourceEventDomainContext,
} from '@datadog/browser-rum';

const timingHeaders = [
  'x-request-time',
  'x-envoy-upstream-service-time',
  'x-request-id',
  'server-timing',
];

const ddKey = 'timing_headers';

type objType = Record<string, string | null>;

export function addTimingHeadersForFetch(event: RumEvent, ctx: RumEventDomainContext) {
  const context = ctx as RumFetchResourceEventDomainContext;
  const headers = context?.response?.headers;

  if (
    headers &&
    event?.context &&
    event?.type === 'resource' &&
    event?.resource?.type === 'fetch'
  ) {
    const obj: objType = {};

    timingHeaders.forEach(headerName => {
      const headerValue = headers.get(headerName);
      obj[headerName] = headerValue;
    });

    event.context[ddKey] = obj;
  }
}
